import loginLayerPopup from '@handlebars/login-layer-popup.hbs';

import { setWindowTemplates } from '../Templates';

(() => {
    setWindowTemplates('login-layer-popup', loginLayerPopup);
})();
